import {
  useMutation,
  useQueryClient,
  UseMutationResult,
  UseMutationOptions,
} from "@tanstack/react-query"
import { guardAppUsage } from "@mimber-client/guards/AppGuard"
import { useServerContext } from "@mimber-client/contexts/ServerContext"
import type { CommunicationTemplateDto, ResponseDto } from "@mimber/schema"
import { communicationTemplatesKeys } from "../communication-templates.utils"

interface DeleteCommunicationTemplateOptions extends Omit<
  UseMutationOptions<ResponseDto<CommunicationTemplateDto>, Error, void>,
  "mutationFn"
> {}

export const useDeleteCommunicationTemplate = (
  templateUuid: string,
  options: DeleteCommunicationTemplateOptions = {}
): UseMutationResult<ResponseDto<CommunicationTemplateDto>, Error, void> => {
  guardAppUsage("mimber-organization", "useDeleteCommunicationTemplate")

  const { server } = useServerContext()
  const queryClient = useQueryClient()

  return useMutation({
    ...options,
    mutationFn: async () => {
      const response = await server.delete<
        ResponseDto<CommunicationTemplateDto>
      >(`communication-templates/${templateUuid}`)
      return response.data
    },
    onSuccess: (response, variables, onMutateResult, context) => {
      queryClient.invalidateQueries({
        queryKey: communicationTemplatesKeys.findAll(),
      })
      queryClient.removeQueries({
        queryKey: communicationTemplatesKeys.findOne(templateUuid),
      })

      if (options?.onSuccess) {
        options.onSuccess(response, variables, onMutateResult, context)
      }
    },
  })
}
